// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__zLt8J","small":"styles_small__EodUf"};